<script setup>
import { computed, ref } from "vue";
import { BDropdown, BDropdownItem } from "bootstrap-vue-next";
import { toPascalCase } from "@/utils/utils.js";

const props = defineProps({
  actions: {
    type: Array,
    default: () => [],
  },
  teleportTo: {
    type: String,
    default: null,
  },
});

const dropdownVisible = ref(false);

const computedActions = computed(() => {
  return props.actions.map((action) => ({
    ...action,
    slotName:
      action.label === "Edit draft"
        ? toPascalCase("Convert to Ticket")
        : toPascalCase(action.label),
  }));
});

const toggleDropdown = () => {
  dropdownVisible.value = !dropdownVisible.value;
};
</script>

<template>
  <div class="three-dots-dropdown">
    <BDropdown
      v-model="dropdownVisible"
      right
      no-caret
      menu-class="three-dots-menu"
      :teleport-to="teleportTo"
    >
      <template #button-content>
        <IconThreeDotsVertical
          class="three-dots-vertical-icon"
          @click.stop="toggleDropdown"
        />
      </template>

      <BDropdownItem
        v-for="(action, index) in computedActions"
        :key="index"
        :class="{ 'is-danger': action.isDanger }"
        @click.stop="action.onClick ? action.onClick() : null"
      >
        <span class="d-flex align-items-center column-gap-2">
          <slot :name="`${action.slotName}-icon`" />
          <span class="text-neutral-400 font-size-sm">
            {{ action.label }}
          </span>
        </span>
      </BDropdownItem>
    </BDropdown>
  </div>
</template>

<style scoped lang="scss">
.three-dots-dropdown {
  display: inline-block;

  :deep(.dropdown) {
    display: flex;

    .btn {
      padding: 0;
      border: none;
      background: transparent;

      svg {
        color: $bluish-gray-700;
      }
    }

    .dropdown-menu {
      border: none;
      box-shadow: 0 2px 12px 0 rgba(125, 144, 165, 0.2);
    }
  }
}
</style>

<style lang="scss">
.three-dots-menu {
  padding: 8px;

  .dropdown-item {
    padding: 8px;
    font-size: $font-size-sm;

    &:hover {
      background: var(--primary-0);
    }
  }

  .is-danger {
    &:hover {
      background: $red-0;
    }

    .dropdown-item {
      &:hover {
        background: $red-0;

        span {
          color: $red-200;
        }

        svg {
          path {
            fill: $red-200;
          }
        }
      }
    }
  }
}
</style>
